export const PAYMENT_STATUS = {
  FAIL: 'paymentFail',
  SUCCESS: 'paymentSuccess',
  HIDDEN: 'paymentHidden',
  PENDING_ANALYSIS: 'pendingAnalysis',
};
